import React from "react";

export default function SectionHeading({
  title,
  aside,
}: {
  title: string;
  aside?: React.ReactNode;
}) {
  return (
    <div className="flex w-full flex-wrap items-center gap-3">
      <h2 className="font-['Geist:SemiBold',_sans-serif] font-semibold text-[#211f26] text-[16px] leading-[24px]">
        {title}
      </h2>
      {aside}
    </div>
  );
}
